import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { category, PromptTemplate, TeilaufgabeType } from '@reflact/ipkv-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PromptTemplateService {
  private http = inject(HttpClient);
  private baseRoute = "/api/admin/prompttemplate";

  public async create(name: string, prompt: string, selectedByDefault: TeilaufgabeType[], category: category | null) {
    const createResult = await firstValueFrom(this.http.post<PromptTemplate>(this.baseRoute + "/create",
      {
        name,
        ...(category != null && { category: category }),
        prompt: prompt,
        selectedByDefault: selectedByDefault,
      }));
    return createResult;
  }

  public async update(opts: { _id: string, name?: string, prompt?: string, selectedByDefault?: TeilaufgabeType[] }) {
    const createResult = await firstValueFrom(this.http.post<PromptTemplate>(this.baseRoute + "/update",
      {
        _id: opts._id,
        ...(opts.name != null && { name: opts.name }),
        ...(opts.prompt != null && { prompt: opts.prompt }),
        ...(opts.selectedByDefault != null && { selectedByDefault: opts.selectedByDefault }),
      }));
    return createResult;
  }

  public async delete(_id: string) {
    const deleteResult = await firstValueFrom(this.http.post<PromptTemplate>(this.baseRoute + "/delete/" + _id, {}));
    return deleteResult;
  }

  public async list(category: string) {
    const list = await firstValueFrom(this.http.get<PromptTemplate[]>(this.baseRoute + "/list/" + encodeURIComponent(category)));
    return list;
  }

  public async listForTeilaufgabe(teilaufgabeId: string) {
    const list = await firstValueFrom(this.http.get<PromptTemplate[]>(this.baseRoute + "/listforteilaufgabe/" + teilaufgabeId));
    return list;
  }

  public async get(_id: string) {
    const list = await firstValueFrom(this.http.get<PromptTemplate>(this.baseRoute + "/get/" + _id));
    return list;
  }
}